import 'nsw-design-system/src/components/accordion/_accordion.scss';
import './accordions.scss';
import nsw from 'nsw-design-system/dist/js/main.js';
import { div as divElem } from '../../scripts/dom-helpers.js';

export default function decorate(block) {
  const accordions = divElem({ class: 'nsw-accordion js-accordion' });
  const isOpen = !!block.classList.contains('open');
  [...block.children].forEach((row) => {
    const [titleDiv, contentDiv] = [...row.children];

    const titleEl = divElem({ class: 'nsw-accordion__title' });
    const contentEl = divElem({ class: 'nsw-accordion__content' });

    if (isOpen) {
      titleEl.classList.add('nsw-accordion__open');
    }

    titleEl.innerText = titleDiv.innerText.trim();
    contentEl.innerHTML = contentDiv.innerHTML;

    accordions.innerHTML += titleEl.outerHTML;
    accordions.innerHTML += contentEl.outerHTML;
  });

  block.innerHTML = accordions.outerHTML;

  const blockAccordions = block.querySelectorAll('.js-accordion');
  if (blockAccordions) {
    blockAccordions.forEach((element) => {
      new nsw.Accordion(element).init();
    });
  }
}
